import { RouteRecordRaw } from 'vue-router'

const WorkspacePage = () =>
  import(/* webpackChunkName: "kanban-workspace" */ './pages/WorkspacePage.vue')

const workspaceMeta = {
  title: 'Tableros',
  auth: {
    requiredPermission: ['projects.view', 'boards.view_any'],
    requiredModule: 'kanban',
    redirect: '/auth/login',
    forbiddenRedirect: '/inicio',
  },
}

export const moduleRoutes: Array<RouteRecordRaw> = [
  {
    path: 'tableros',
    name: 'kanban-workspace',
    component: WorkspacePage,
    meta: workspaceMeta,
  },
  {
    path: 'tableros/:projectSlug',
    name: 'kanban-workspace-project',
    component: WorkspacePage,
    meta: workspaceMeta,
  },
  {
    path: 'tableros/:projectSlug/:boardSlug',
    name: 'kanban-workspace-board',
    component: WorkspacePage,
    meta: workspaceMeta,
  },
]
